// Reviews Wall (Stamped) -> Swiper-based horizontal scroll without changing styles/layout
(function () {
  function upgradeLazyImages(root) {
    var images = root.querySelectorAll('img');
    images.forEach(function (img) {
      var dataSrc = img.getAttribute('data-src') || img.getAttribute('data-original');
      var dataSrcset = img.getAttribute('data-srcset') || img.getAttribute('data-original-set');
      if (dataSrc) img.src = dataSrc;
      if (dataSrcset) img.srcset = dataSrcset;
      img.loading = 'eager';
      img.classList && img.classList.remove('lazyload');
    });
  }
  function normalizeSrcFromImg(img) {
    var src = img.getAttribute('data-src') || img.getAttribute('data-original') || img.getAttribute('src') || '';
    if (!src) {
      var srcset = img.getAttribute('data-srcset') || img.getAttribute('data-original-set') || img.getAttribute('srcset') || '';
      if (srcset) src = srcset.split(',')[0].trim().split(' ')[0];
    }
    if (src.indexOf('?') > -1) src = src.split('?')[0];
    return src;
  }
  function shuffle(arr) {
    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = arr[i]; arr[i] = arr[j]; arr[j] = t;
    }
    return arr;
  }
  function cloneImage(img) {
    var copy = document.createElement('img');
    var src = img.getAttribute('src');
    var dataSrc = img.getAttribute('data-src') || img.getAttribute('data-original');
    var srcset = img.getAttribute('srcset');
    var dataSrcset = img.getAttribute('data-srcset') || img.getAttribute('data-original-set');
    if (dataSrc) copy.setAttribute('src', dataSrc); else if (src) copy.setAttribute('src', src);
    if (dataSrcset) copy.setAttribute('srcset', dataSrcset); else if (srcset) copy.setAttribute('srcset', srcset);
    copy.alt = img.alt || 'Customer Photo';
    copy.loading = 'eager';
    return copy;
  }
  function buildSwiper(widget) {
    if (!widget) return false;
    if (widget.dataset.swiperBuilt === 'true') return true;

    var content = widget.parentElement; // .stamped-reviews-wall__content
    if (!content) return false;

    // Ensure images are present before snapshotting
    var imgs = widget.querySelectorAll('img');
    if (!imgs || imgs.length === 0) return false;
    var hasRealSrc = Array.from(imgs).some(function (img) {
      var ds = img.getAttribute('data-src') || img.getAttribute('data-original');
      var s = img.getAttribute('src');
      return !!ds || (s && s.length > 0 && !/transparent|placeholder|data:image/.test(s));
    });
    if (!hasRealSrc) return false; // wait until stamped fills src/data-src

    // Build two-row swipers using individual images
    var rowsContainer = document.createElement('div');
    rowsContainer.className = 'stamped-rows-swiper';

    var swiperTop = document.createElement('div');
    swiperTop.className = 'swiper stamped-reviews-swiper stamped-reviews-swiper--top';
    var wrapperTop = document.createElement('div');
    wrapperTop.className = 'swiper-wrapper';

    var swiperBottom = document.createElement('div');
    swiperBottom.className = 'swiper stamped-reviews-swiper stamped-reviews-swiper--bottom';
    var wrapperBottom = document.createElement('div');
    wrapperBottom.className = 'swiper-wrapper';

    // Filter out product images: keep only customer UGC
    var filtered = Array.from(imgs).filter(function (img) {
      var alt = (img.getAttribute('alt') || '').toLowerCase();
      if (alt.includes('product image') || alt.includes('product')) return false;
      var t1 = (img.getAttribute('data-type') || '').toLowerCase();
      if (t1 === 'product') return false;
      var holder = img.closest('[data-type]');
      var t2 = holder ? (holder.getAttribute('data-type') || '').toLowerCase() : '';
      if (t2 === 'product') return false;
      return true;
    });

    // Deduplicate & shuffle to avoid consecutive duplicates
    var uniq = [];
    var seen = new Set();
    filtered.forEach(function(img){
      var key = normalizeSrcFromImg(img);
      if (key && !seen.has(key)) { seen.add(key); uniq.push(img); }
    });
    shuffle(uniq);

    // Distribute images into two rows (交替分配保证两行)
    uniq.forEach(function (img, idx) {
      var slide = document.createElement('div');
      slide.className = 'swiper-slide';
      var cloned = cloneImage(img);

      // Preserve click behavior to open the related review
      var origAnchor = img.closest('a');
      var wrapperEl;
      if (origAnchor) {
        wrapperEl = document.createElement('a');
        wrapperEl.className = 'stamped-ugc-link';
        var href = origAnchor.getAttribute('href') || '';
        if (href) wrapperEl.href = href;
        wrapperEl.target = origAnchor.getAttribute('target') || '_blank';
        wrapperEl.rel = 'noopener';
        wrapperEl.addEventListener('click', function (e) {
          try {
            e.preventDefault();
            // Try to trigger Stamped's built-in modal via the original anchor
            origAnchor.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
            // Fallback: open the link directly if no modal appears
            setTimeout(function(){
              var modal = document.querySelector('.stamped-modal, .stamped-lightbox, .stamped-popup');
              if (!modal && href) window.open(href, wrapperEl.target);
            }, 100);
          } catch (err) {
            if (href) window.open(href, wrapperEl.target);
          }
        });
      } else {
        wrapperEl = document.createElement('div');
      }

      wrapperEl.appendChild(cloned);
      slide.appendChild(wrapperEl);
      if (idx % 2 === 0) {
        wrapperTop.appendChild(slide);
      } else {
        wrapperBottom.appendChild(slide);
      }
    });

    swiperTop.appendChild(wrapperTop);
    swiperBottom.appendChild(wrapperBottom);
    rowsContainer.appendChild(swiperTop);
    rowsContainer.appendChild(swiperBottom);
    content.appendChild(rowsContainer);

    // Hide original widget to prevent duplicate display; keep for Stamped
    widget.style.display = 'none';

    // Init two Swipers for continuous horizontal scroll
    var options = {
      slidesPerView: 'auto',
      spaceBetween: 16,
      loop: true,
      speed: 12000,
      autoplay: { delay: 0, disableOnInteraction: false, pauseOnMouseEnter: false },
      allowTouchMove: false,
      observer: true,
      observeParents: true,
      loopAdditionalSlides: 20,
      loopPreventsSliding: false,
    };
    var sTop = new Swiper(swiperTop, options);
    var sBottom = new Swiper(swiperBottom, options);

    [sTop, sBottom].forEach(function(sw){
      try { sw.autoplay && sw.autoplay.start(); } catch(e) {}
      var resume = function(){ try { sw.autoplay && sw.autoplay.start(); } catch(e) {} };
      sw.el.addEventListener('mouseenter', resume);
      sw.el.addEventListener('mouseleave', resume);
      sw.el.addEventListener('click', resume);
      document.addEventListener('visibilitychange', function(){ if (!document.hidden) resume(); });
    });

    // Remove broken images gracefully and update swipers
    function pruneBroken(wrapperEl) {
      Array.from(wrapperEl.querySelectorAll('img')).forEach(function (imgEl) {
        var slideEl = imgEl.closest('.swiper-slide');
        var removeSlide = function(){ if(slideEl && slideEl.parentNode){ slideEl.parentNode.removeChild(slideEl); } };
        if (imgEl.complete && imgEl.naturalWidth === 0) {
          removeSlide();
        } else {
          imgEl.addEventListener('error', removeSlide);
        }
      });
    }
    pruneBroken(wrapperTop);
    pruneBroken(wrapperBottom);

    widget.dataset.swiperBuilt = 'true';
    return true;
  }

  function init() {
    var widget = document.getElementById('stamped-reviews-widget');
    if (!widget) return;

    // If already rendered content, build immediately
    if (buildSwiper(widget)) return;

    // Observe Stamped rendering
    var obs = new MutationObserver(function () {
      if (buildSwiper(widget)) { obs.disconnect(); }
    });
    obs.observe(widget, { childList: true, subtree: true });

    // Fallback polling in case of late async render
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (buildSwiper(widget) || tries > 20) { clearInterval(timer); }
    }, 500);
  }

  // Auto init and expose manual trigger
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
    window.addEventListener('load', init);
  } else {
    init();
  }
  window.initStampedScroller = init;
})();